import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './containers/App';
import { getRootDom } from './utils/helpers';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(getRootDom());
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 

/*
if('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/wp.js').then((reg) => {
    console.log('serviceWorker register', reg);
  }).catch((err) => {
    console.log('serviceWorker register error', err);
  });
}
*/